<template>
  <EditorPageWrapper
    wrapperId="journey-orientation"
    :iconComponent="AppGuideIcon"
    title="JOURNEY ORIENTATION"
    page="journeyorientation"
    collection="journeyorientation"
  />
</template>

<script>
  import EditorPageWrapper from '@/components/utilities/EditorPageWrapper.vue'
  import AppGuideIcon from '@/assets/icons/AppGuideIcon.vue'

  export default {
    name: 'JourneyOrient',
    components: {
      EditorPageWrapper,
    },
    setup() {
      return {
        AppGuideIcon,
      }
    },
  }
</script>
